import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

// Territory picker on the artist profile form: shows a searchable multi-country
// select (rendered as removable chips) only when "Specific countries" is chosen.
// Connects to data-controller="territory"
export default class extends Controller {
  static targets = ["countries", "select"]

  connect() {
    if (this.hasSelectTarget && !this.selectTarget.tomselect) {
      this.tomSelect = new TomSelect(this.selectTarget, {
        plugins: ["remove_button"],
        maxOptions: null,
        hideSelected: true,
        closeAfterSelect: false,
        placeholder: this.selectTarget.dataset.placeholder
      })
    }
    this.toggle()
  }

  disconnect() {
    this.tomSelect?.destroy()
  }

  toggle() {
    const checked = this.element.querySelector('input[type="radio"]:checked')
    const custom = checked?.value === "custom"
    this.countriesTarget.classList.toggle("hidden", !custom)
    if (!custom) this.tomSelect?.clear(true)
  }
}
